import React, { useState } from 'react';

const BodyFatCalculator = ({ pol, visina, struk, vrat, kuk }) => {
  const [gender, setGender] = useState(pol);
  const [height, setHeight] = useState(visina);
  const [waist, setWaist] = useState(struk);
  const [neck, setNeck] = useState(vrat);
  const [hips, setHips] = useState(kuk); // Only for women
  const [bodyFat, setBodyFat] = useState(null);

  const handleCalculate = () => {
    // Check for missing inputs
    if (!height) {
      alert('Molimo unesite visinu.');
      return;
    }
    if (!waist) {
      alert('Molimo unesite obim struka.');
      return;
    }
    if (!neck) {
      alert('Molimo unesite obim vrata.');
      return;
    }
    if (gender === 'zenski' && !hips) {
      alert('Molimo unesite obim bokova.');
      return;
    }

    const heightCm = parseFloat(height);
    const waistCm = parseFloat(waist);
    const neckCm = parseFloat(neck);
    const hipsCm = hips ? parseFloat(hips) : 0;

    let bodyFatPercentage = 0;

    if (gender === 'muski') {
      bodyFatPercentage =
        86.010 * Math.log10(waistCm - neckCm) -
        70.041 * Math.log10(heightCm) +
        36.76;
    } else {
      bodyFatPercentage =
        163.205 * Math.log10(waistCm + hipsCm - neckCm) -
        97.684 * Math.log10(heightCm) -
        78.387;
    }

    setBodyFat(bodyFatPercentage);
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md border border-gray-500">
      <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">Kalkulator Telesne Masti</h1>

      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">Pol</label>
        <select
          value={gender}
          onChange={(e) => setGender(e.target.value)}
          className="border border-gray-300 rounded-lg p-3 w-full"
        >
          <option value="zenski">Žensko</option>
          <option value="muski">Muško</option>
        </select>
      </div>

      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">Visina (cm)</label>
        <input
          type="number"
          placeholder="Visina (cm)"
          value={height}
          onChange={(e) => setHeight(e.target.value)}
          className="border border-gray-300 rounded-lg p-3 w-full"
        />
      </div>

      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">Obim struka (cm)</label>
        <input
          type="number"
          placeholder="Struk (cm)"
          value={waist}
          onChange={(e) => setWaist(e.target.value)}
          className="border border-gray-300 rounded-lg p-3 w-full"
        />
      </div>

      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">Obim vrata (cm)</label>
        <input
          type="number"
          placeholder="Vrat (cm)"
          value={neck}
          onChange={(e) => setNeck(e.target.value)}
          className="border border-gray-300 rounded-lg p-3 w-full"
        />
      </div>

      {gender === 'zenski' && (
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">Obim bokova (cm)</label>
          <input
            type="number"
            placeholder="Bokovi (cm)"
            value={hips}
            onChange={(e) => setHips(e.target.value)}
            className="border border-gray-300 rounded-lg p-3 w-full"
          />
        </div>
      )}

      <button
        onClick={handleCalculate}
        className="w-full bg-blue-600 text-white rounded-lg py-3 hover:bg-blue-700 transition duration-300"
      >
        Izračunaj Procenat Masti
      </button>

      {bodyFat !== null && (
        <div className="mt-6 text-center">
          <h2 className="text-2xl font-semibold text-gray-800">
            Procenat telesne masti: {bodyFat.toFixed(2)}%
          </h2>
        </div>
      )}
    </div>
  );
};

export default BodyFatCalculator;
